import { InformationTooltip, UIText2 } from '@cian/ui-kit';
import { IconFunctionalWarningSign16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './TourFrameNotification.css';

interface ITourFrameNotificationProps {
  children: React.ReactNode;
}

export const TourFrameNotification: React.FC<ITourFrameNotificationProps> = ({ children }) => {
  const [isTooltipOpen, setIsTooltipOpen] = React.useState(true);

  /* istanbul ignore next */
  const handleTooltipClose = React.useCallback(() => {
    setIsTooltipOpen(false);
  }, []);

  return (
    <div className={styles['container']}>
      <InformationTooltip
        open={isTooltipOpen}
        content={
          <div className={styles['tooltip-content']}>
            <IconFunctionalWarningSign16 />
            <UIText2>Мебель и отделка использованы для примера</UIText2>
          </div>
        }
        onClose={handleTooltipClose}
        placement="bottom-start"
      >
        <div className={styles['tooltip-trigger']} />
      </InformationTooltip>
      {children}
    </div>
  );
};
